import React, { Component, useState, useEffect } from 'react'
import ReactDOM from 'react-dom'

import './css/styles.scss'

import CartClass from './../../../../../../../js/classes/Cart'
import ScrollClass from './../../../../../../../js/classes/Scroll'

import Loading from './Loading.jsx'

import Cart from './Cart.jsx'
import Empty from './Empty.jsx'
import Gifts from './Gifts.jsx'
import Promocode from './Promocode.jsx'
import Summary from './Summary.jsx'
import Actions from './Actions.jsx'

const CartApp = () => {
    const [cart, setCart] = useState(null),
    [gifts, setGifts] = useState([]),
    [isLoading, setLoading] = useState(false),
    [isHideErrors, setHideErrors] = useState(false)

    const checkAmount = (items, cb) => {
        let isErrors = false

        items.forEach((cartItem) => {
            if (cartItem.OLD_QUANTITY > cartItem.QUANTITY) {
                const numberInput = document.querySelector(`.input-number__count[data-id="${ cartItem.ID }"]`)

                if (numberInput) numberInput.value = cartItem.AMOUNT
            }
        })

        if (cb) cb()
    }, 
    refetch = (cb) => {
        setLoading(true)
        setHideErrors(false)

        CartClass.getGifts((_err, gifts) => {
            if (_err) {
                
            } else {
                setGifts(gifts)
            }

            setLoading(false)

            ScrollClass.scrollTo('.happy-cart__item-error-amount')

            CartClass.setCartQuantity()

            CartClass.getCart((err, cart) => {
                if (err) {
                    
                } else {
                    setCart(cart)
    
                    if (!(cart.items && cart.items.length > 0)) {
                        setLoading(false)
                    }
    
                    setTimeout(() => {
                        checkAmount(cart.items, () => {
                            
                        })
                    }, 0)
                }
                
                if (cb) cb(err, cart)
            }, undefined, true)
        })
    }

    useEffect(() => {
        refetch()
    }, [])

    return <div className={ `happy-cart` + (isLoading ? ` happy-cart__loading` : ``) }>
        { cart ? <>
            { cart.items && cart.items.length > 0 ? <>
                <div className="happy-cart__title">
                    <div className="happy-cart__title-left">
                        В корзине к заказу { cart.count_format }
                    </div>
                    <div className="happy-cart__min-order-summary">
                        { cart?.summary < 1000 && 'Минимальная сумма заказа 1 000 ₽' }
                    </div> 
                </div>

                <div className="happy-cart__data">
                    <Cart
                        refetch={ refetch }
                        setLoading={ setLoading }
                        cart={ cart }
                        isHideErrors={ isHideErrors }
                        setHideErrors={ setHideErrors }
                    />

                    <Gifts
                        refetch={ refetch }
                        setLoading={ setLoading }
                        gifts={ gifts }
                        setGifts={ setGifts }
                    />
                </div>

                <div className="happy-cart__footer">
                    <Promocode refetch={ refetch } setLoading={ setLoading } cart={ cart } />
                    <Summary refetch={ refetch } cart={ cart } />
                </div>

                <Actions refetch={ refetch } setHideErrors={ setHideErrors } cart={ cart } />
            </> : <Empty /> }
        </> : <Loading /> }
    </div>
}

const container = document.getElementById('root-cart')

if (container) ReactDOM.render(<CartApp />, container)